<template>
    <Dropdown
        v-if="agentStatuses && agentStatuses.length > 0"
        class="dropdown-agents"
        :color="colorDropdown"
        :title="title"
        small
    >
        <li class="px-2 pt-2">
            <Users v-model="customAgent" placeholder="Search" :searchFunction="fetchAgents" ref="users" />
        </li>
        <hr />
        <li v-for="(agent, index) in agentStatuses" :key="index">
            <button
                @click.prevent="setAgent(agent.type)"
                class="dropdown-item text-xs"
                :class="getBtnClasses(agent.type)"
            >
                {{ agent.name }}
            </button>
        </li>
    </Dropdown>
</template>

<script>
    import { Dropdown } from '@tech_hexeko/design-system'
    import agentStatuses from '@/components/Agents/statuses.js'
    import Users from '@tech_hexeko/design-system/src/components/Form/Models/Users'
    import Tasks from '@/mixins/Tasks'

    export default {
        name: 'DropdownAgents',
        mixins: [Tasks],
        components: { Dropdown, Users },
        data() {
            return {
                agentStatuses,
                agent: '',
                customAgent: null,
            }
        },
        props: {
            title: {
                type: String,
                default: 'Filter by agent',
            },
            value: {
                type: [Number, String],
                default: '',
            },
        },
        computed: {
            colorDropdown() {
                return this.value ? 'success' : 'secondary'
            },
            finalAgent() {
                return this.customAgent || this.agent
            },
        },
        methods: {
            fetchAgents(search) {
                return this.$api.users.get({ permission: this.taskPermission, search })
            },
            getBtnClasses(typeAgent) {
                return this.value === typeAgent ? 'bg-primary text-white' : 'bg-white'
            },
            setAgent(agent) {
                this.$refs.users.$refs.usersSelect.$refs.multiselect.select([])
                const newAgent = this.agent === agent ? '' : agent
                this.agent = newAgent
            },
        },
        watch: {
            finalAgent: {
                handler(agent) {
                    this.$emit('input', agent)
                },
            },
        },
    }
</script>

<style type="text/css">
    .dropdown-agents ul.dropdown-menu {
        min-width: 400px;
    }
</style>
